import Button from "components/Button";
import Content from "components/Content";
import Label from "components/Label";
import text from "constants/text";
import Image from "next/image";
import { useRouter } from "next/router";
import React, { FC } from "react";
import { HiOutlineCheck as CheckIcon } from "react-icons/hi";

import styles from "./styles.module.scss";

const WeProvide: FC = () => {
  const { services } = text.partner_network.we_provide;

  const router = useRouter();

  return (
    <Content
      contentClassName={styles.container}
      containerClassName={styles.wrapper}
    >
      <div className={styles.services}>
        {services.map(
          ({
            pre_title: preTitle,
            title,
            description,
            includes,
            cta,
            image
          }) => (
            <div className={styles.service}>
              <div className={styles.serviceInfo}>
                <Label
                  variant="s-capitalized"
                  className={styles.preTitle}
                  color="white"
                >
                  {preTitle}
                </Label>
                <Label className={styles.title} variant="h" color="white">
                  {title}
                </Label>
                <Label className={styles.description} variant="s" color="white">
                  {description}
                </Label>
                <div className={styles.includes}>
                  {includes.map((item) => (
                    <div className={styles.item}>
                      <CheckIcon className={styles.check} />
                      <Label
                        variant="s"
                        className={styles.itemLabel}
                        color="white"
                      >
                        {item}
                      </Label>
                    </div>
                  ))}
                </div>
                <Button variant="cta" onClick={() => router.push(cta.to)}>
                  {cta.reads}
                </Button>
              </div>
              <div className={styles.serviceImage}>
                <Image alt="" src={image} layout="fill" objectFit="cover" />
              </div>
            </div>
          )
        )}
      </div>
    </Content>
  );
};

export default WeProvide;
